/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Language_PlInputs */

const en_language_pl = /** @type {(inputs: Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polish`)
};

const pl_language_pl = /** @type {(inputs: Language_PlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polski`)
};

/**
* | output |
* | --- |
* | "Polish" |
*
* @param {Language_PlInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const language_pl = /** @type {((inputs?: Language_PlInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Language_PlInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_language_pl(inputs)
	return en_language_pl(inputs)
});